import { render, staticRenderFns } from "./help.vue?vue&type=template&id=c47864ee&scoped=true&"
var script = {}
import style0 from "./help.vue?vue&type=style&index=0&id=c47864ee&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c47864ee",
  null
  
)

export default component.exports